export const guidsAreEqual = (guid1, guid2) =>
  guid1?.toLowerCase().replace(/-/g, "") === guid2?.toLowerCase().replace(/-/g, "");